<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <!--    <template #header>-->
    <!--      <h3 class="dialogTitle">Tìm kiếm nâng cao</h3>-->
    <!--    </template>-->

    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Báo cáo tổng hợp theo dõi chỉ đạo
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        ref="form"
        label-position="left"
        label-width="150px"
      >
        <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item label="Thời gian chỉ đạo" class="formItem">
              <el-date-picker
                v-model="commandsDateRange"
                type="daterange"
                format="dd/MM/yyyy"
                class="style-fullWidth input-border__bottom input-border__radius__0"
                :picker-options="dateQuickFilterOption"
                range-separator="_"
                start-placeholder="_"
                end-placeholder="_"
                align="right"
                :clearable="true"
                @change="dateRangeChanged"
                size="medium"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="16">
            <el-form-item label="Hạn hoàn thành" class="formItem">
              <el-date-picker
                v-model="deadlineRange"
                type="daterange"
                format="dd/MM/yyyy"
                class="style-fullWidth input-border__bottom input-border__radius__0"
                :picker-options="dateQuickFilterOption"
                range-separator="_"
                start-placeholder="_"
                end-placeholder="_"
                align="right"
                @change="deadlineRangeChanged"
                size="medium"
                clearable
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Lĩnh vực" class="formItem">
              <el-select
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="form.sectors"
                placeholder="Lĩnh vực"
                size="medium"
                filterable
                clearable
                multiple
              >
                <el-option
                  v-for="item in sectors"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Lãnh đạo chỉ đạo" class="formItem">
              <el-select
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="form.directiveIds"
                placeholder="Lãnh đạo phụ trách"
                size="medium"
                filterable
                clearable
                multiple
              >
                <el-option
                  v-for="item in listDirectives"
                  :key="item.id"
                  :label="`${item.fullName} - ${item.positionName}`"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Lãnh đạo phụ trách" class="formItem">
              <el-select
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="form.performIds"
                placeholder="Lãnh đạo phụ trách"
                size="medium"
                filterable
                clearable
                multiple
              >
                <el-option
                  v-for="item in listDirectives"
                  :key="item.id"
                  :label="`${item.fullName} - ${item.positionName}`"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Trạng thái" class="formItem">
              <el-select
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="form.commandStatusList"
                placeholder="Trạng thái"
                size="medium"
                filterable
                clearable
                multiple
              >
                <el-option
                  v-for="item in commandStatusSelectOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Đánh giá tiến độ" class="formItem">
              <el-select
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="form.progressStatus"
                placeholder="Trạng thái"
                size="medium"
                filterable
                clearable
              >
                <el-option
                  v-for="item in progressStatusSelectOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button class="dialogBtnPrimary" @click="exportReportExcel">
          <i class="fa fa-file-excel" aria-hidden="true"></i>
          &nbsp;Xuất Excel
        </el-button>
        <el-button class="btn__cancel btn-none__border" @click="resetForm"
          >Khởi tạo
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import constants from "../../../constants";
import dateUtils from "../../../dateUtils";
import dateFormatter from "../../../filters/dateFormatter";
import utils from "../../../services/utils";
import CustomDialog from "../../common/custom-dialog";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import hcFlowService from "../../../services/hcFlowService";

export default {
  name: "hc-command-report-th-dialog",
  components: { CustomDialog },
  filters: { dateFormatter },
  props: ["isOpen", "inputForm"],

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },

    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    }
  },

  data() {
    return {
      departments: null,
      commandsDateRange: null,
      deadlineRange: null,
      sectors: null,
      dateQuickFilterOption: null,
      commandStatusSelectOptions: null,
      progressStatusSelectOptions: null,
      listDirectives: null,
      hcFlow: null,
      form: {
        fromCommandsDate: null,
        toCommandsDate: null,
        fromDeadline: null,
        toDeadline: null,
        sectors: null,
        directiveIds: null,
        performIds: null,
        commandStatusList: null,
        progressStatus: null
      }
    };
  },

  async created() {
    this.initSelectOptions();
    this.initDateQuickFilterOption();
    this.initQuery();
    await this.loadHcFlow();
    await this.loadDirectiveActors();
  },

  methods: {
    resetForm() {
      this.initQuery();
    },

    initDateQuickFilterOption() {
      this.dateQuickFilterOption = {
        shortcuts: [
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.THIS_MONTH
          ),
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.LAST_MONTH
          ),
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.NAM_NAY
          )
        ]
      };
    },

    dateRangeChanged() {
      this.form.fromCommandsDate =
        this.commandsDateRange && this.commandsDateRange[0]
          ? this.commandsDateRange[0].getTime()
          : undefined;
      this.form.toCommandsDate =
        this.commandsDateRange && this.commandsDateRange[1]
          ? this.commandsDateRange[1].getTime()
          : undefined;
    },

    initQuery() {
      this.form = utils.merge(this.form, this.inputForm);
      this.initCommandsDateRange();
      this.initDeadlineRange();
    },

    initCommandsDateRange() {
      if (this.form.fromCommandsDate && this.form.toCommandsDate) {
        this.commandsDateRange = [
          dateUtils.toMoment(this.form.fromCommandsDate),
          dateUtils.toMoment(this.form.toCommandsDate)
        ];
      } else {
        this.commandsDateRange = dateUtils.getDatesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
        );
        let defaultTimeRange = dateUtils.getTimesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
        );
        this.form.fromCommandsDate = defaultTimeRange[0];
        this.form.toCommandsDate = defaultTimeRange[1];
      }
    },

    initDeadlineRange() {
      this.deadlineRange = utils.initTimeRange(
        this.form.fromDeadline,
        this.form.toDeadline
      );
    },

    validate() {
      return new Promise(resolve => {
        resolve();
      });
    },

    exportReportExcel() {
      let query = utils.merge(this.form, {
        userDeptRoleId: this.userDeptRoleId
      });
      let baseServiceURL = constants.BASE_SERVICE_URL;
      let reportUrl = constants.REPORT.HC_COMMANDS.BAO_CAO_TONG_HOP_URL;
      window.open(
        `${baseServiceURL}${reportUrl}?${utils.serialize(query)}`,
        "_blank "
      );
    },

    deadlineRangeChanged() {
      utils.timeRangeChanged(this.deadlineRange, (from, to) => {
        this.form.fromDeadline = from;
        this.form.toDeadline = to;
      });
    },

    initSelectOptions() {
      hanhChinhUtils
        .buildHcCommandSectorOptions()
        .then(sectors => (this.sectors = sectors));
      this.commandStatusSelectOptions = hanhChinhUtils.buildHcCommandStatusOptions();
      this.progressStatusSelectOptions = this.buildProgressStatusOptions();
    },

    buildProgressStatusOptions() {
      return [
        {
          id: constants.HC_CASE_COMMANDS.PROGRESS_STATUS.DUNG_TIEN_DO,
          name: "Đúng tiến độ"
        },
        { id: constants.HC_CASE_COMMANDS.PROGRESS_STATUS.CHAM, name: "Chậm" }
      ];
    },

    loadHcFlow() {
      return hcFlowService
        .getHcFlowAlternativeForHcCommands()
        .then(response => (this.hcFlow = response.data));
    },

    loadDirectiveActors() {
      return userDeptRoleViewService
        .findAllForHcCommands(this.hcFlow.deptId)
        .then(response => (this.listDirectives = response.data));
    },
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/report/hcCommands/hc-command-report-th-dialog.vue